import './item-search-result-card.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";

import { SearchResult } from '@skinsoft/types';

import { searchResultSelectors } from '@skinsoft/search-data-store';

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { BasicItemCard } from '../basic-item-card';
import { LocalizedString } from '@skinsoft/ui';

@Component({
    components: {
        sLocalizedString: LocalizedString,
        sBasicItemCard: BasicItemCard,
    },
    props: {
        item: {
            type: Object as PropType<SearchResult>,
        },
    },
    template: require('./item-search-result-card.html')
})
export class ItemSearchResultCard extends ReactiveVue {
    private item: SearchResult

    private get title(): string {
        return searchResultSelectors.title(this.item, this.$i18n.locale) ?? ""
    }
}